import Axios from 'axios';
import { tsvParse as d3TsvParse } from 'd3-dsv';
import { getTimeLineValues } from '../../utils';
import DataSets from '../datasets';

const LOAD_START = 'App/AppState/LOAD_START';
const LOAD_SUCCESS = 'App/AppState/LOAD_SUCCESS';
const LOAD_ERROR = 'App/AppState/LOAD_ERROR';

const SET_DATASET = 'App/AppState/SET_DATASET';

const SET_YEAR = 'App/AppState/SET_YEAR';
const RESET_GROUP_FILTER = 'App/AppState/RESET_GROUP_FILTER';
const SET_PLAYING = 'App/AppState/SET_PLAYING';

const TOGGLE_FAQ = 'App/AppState/TOGGLE_FAQ';
const TOGGLE_EMBED = 'App/AppState/TOGGLE_EMBED';


let playInterval = null;

let cache = {};

const initialState = {
  loading: true,
  data: false,
  year: 2014,
  currentDataSet: false,
  allData: false,
  subData: false,
  isPlaying: false,
  datasets: DataSets,
  faqActive: false,
  embedActive: false
}

export function loadData(id = 'all') {
  return dispatch => {
    dispatch({ type: LOAD_START });

    if (cache[id] !== undefined) {
      dispatch({ type: LOAD_SUCCESS, data: cache[id], id });
    } else {
      Axios.get(`data/data_${id}.csv`)
        .then(res => {
          const data = d3TsvParse(res.data);
          cache[id] = data;
          dispatch({ type: LOAD_SUCCESS, data, id });
        })
        .catch(err => dispatch({ type: LOAD_ERROR }));
      }
    }
}

export function setYear(year) {
  return { type: SET_YEAR, year };
}

export function setDataSet(name) {
  return { type: SET_DATASET, name };
}

export function resetGroupFilter() {
  return { type: RESET_GROUP_FILTER };
}

function setPlaying(isPlaying) {
  if(!isPlaying && playInterval) {
    clearInterval(playInterval);
  }

  return { type: SET_PLAYING, isPlaying };
}

export function togglePlaying() {
  return (dispatch, getState) => {

    const { AppState: { isPlaying, allData }, AppState } = getState();

    setPlaying(!isPlaying);

    if (isPlaying) {
      return dispatch(setPlaying(false));
    }

    dispatch(setPlaying(true));

    // get the years from all data obj
    const timelineValues = getTimeLineValues(allData[0]);
    let index = 1;

    // when we are at the end of the timeline we start from 0
    // otherwise we start at the current pos
    if (AppState.year === 2014) {
      dispatch(setYear(timelineValues[0]));
    } else {
      index = timelineValues.indexOf(AppState.year);
      dispatch(setYear(timelineValues[index]));
      index++;
    }

    playInterval = setInterval(() => {
      if (index >= timelineValues.length) {
        return dispatch(setPlaying(false));
      }
      dispatch(setYear(timelineValues[index]));
      index++;
    }, 500);
  };
}

export function toggleFaq() {
  return { type: TOGGLE_FAQ };
}

export function toggleEmbed() {
  return { type: TOGGLE_EMBED };
}


export default function AppReducer(state = initialState, action = {}) {
  switch(action.type) {

    case LOAD_START:
      return Object.assign({}, state, { loading: true });

    case LOAD_SUCCESS:
      return action.id === 'all' ? Object.assign({}, state, {
        loading: false,
        allData: action.data
      }) : Object.assign({}, state, {
        loading: false,
        subData: action.data
      });

    case SET_YEAR:
      return Object.assign({}, state, { year: action.year });

    case SET_DATASET:
      return Object.assign({}, state, { currentDataSet: action.name });

    case RESET_GROUP_FILTER:
      return Object.assign({}, state, { subData: false, currentDataSet: false });

    case SET_PLAYING:
      return Object.assign({}, state, { isPlaying: action.isPlaying });

    case TOGGLE_FAQ:
      return Object.assign({}, state, { faqActive: !state.faqActive, embedActive: false });

    case TOGGLE_EMBED:
      return Object.assign({}, state, { embedActive: !state.embedActive, faqActive: false });

    default:
      return Object.assign({}, state);
  }
};



/** WEBPACK FOOTER **
 ** ./src/modules/App/AppState.js
 **/